import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AssignableRole } from '../../domain/models/assignable-role.model';
import { ClientAppAccessGrantInput, ClientAppAccount } from '../../domain/models/client-app-access.model';
import { LocalClient } from '../../domain/models/local-client.model';
import { LocalClientCreateInput } from '../../domain/models/local-client-create-input.model';
import { ILocalClientsRepository } from '../../domain/repositories/local-clients.repository';
import { LocalClientsRemoteDatasource } from '../datasources/remote/local-clients.remote-datasource';
import { LocalClientMapper } from '../mappers/local-client.mapper';

@Injectable()
export class LocalClientsRepositoryImpl implements ILocalClientsRepository {
  private readonly datasource = inject(LocalClientsRemoteDatasource);
  private readonly mapper = inject(LocalClientMapper);

  public create(input: LocalClientCreateInput): Observable<LocalClient> {
    const payload = this.mapper.toCreatePayload(input);
    return this.datasource.create(input.organizationId, payload).pipe(map((dto) => this.mapper.toLocalClient(dto)));
  }

  public listAppAccounts(organizationId: number): Observable<readonly ClientAppAccount[]> {
    return this.datasource.list(organizationId).pipe(map((dtos) => this.mapper.toClientAppAccounts(dtos)));
  }

  public grantAppAccess(organizationId: number, input: ClientAppAccessGrantInput): Observable<LocalClient> {
    const payload = this.mapper.toGrantAppAccessPayload(input);
    return this.datasource.grantAppAccess(organizationId, payload).pipe(map((dto) => this.mapper.toLocalClient(dto)));
  }

  public resendInvitation(organizationId: number, clientId: number): Observable<void> {
    return this.datasource.resendInvitation(organizationId, clientId);
  }

  public listRoles(): Observable<readonly AssignableRole[]> {
    return this.datasource.listRoles().pipe(map((dtos) => this.mapper.toAssignableRoles(dtos)));
  }
}
